import { combineReducers } from 'redux'

import app from './app'
import list from './list'
import item from './item'


export default combineReducers({
  app,
  list,
  item,
})
